const CREDIT_CALC_ID = 'credit-calculator';
const CREDIT_FORM_ID = 'loan-application-form';
const CALLBACK_FORM_ID = 'callback-form';

const CREDIT_APPLICATION_TEMPLATES_MAP = {
    BUSINESS: 'BusinessTemplate',
    DEFAULT: 'DefaultTemplate',
};

const MAX_SEARCH_QUERY_LENGTH = 1000;

export {
    CREDIT_CALC_ID,
    CREDIT_FORM_ID,
    CALLBACK_FORM_ID,
    MAX_SEARCH_QUERY_LENGTH,
    CREDIT_APPLICATION_TEMPLATES_MAP,
};
